import {videoUrlChange } from './videoUrlChange';
// Regex to match the entire <span> element with audio/video
const spanRegex = /<span[^>]*data-type=["']audioplayer["'][^>]*><\/span>/g;
const videoRegex = /<span[^>]*data-type=["']videoplayer["'][^>]*><\/span>/g;
// Regex to extract the data-src attribute specifically
const srcRegex = /data-src=["']([^"']+)["']/i;
//Regex for image in audio types
const imageRegex = /data-img_src=["']([^"']+)["']/i;
const widthRegex = /width=["']([^"']+)["']/i;
const imageHeightRegex=/data-img_height=["']([^"']+)["']/i;
const imageWidthRegex=/data-img_width=["']([^"']+)["']/i;
const textRegex = /data-text=["']([^"']+)["']/i;
const videoHeightRegex=/data-height=["']([^"']+)["']/i;
const videoWidthRegex=/data-width=["']([^"']+)["']/i;

//regex for student response
const textImageRegex = /<img[^>]*data-asset-path="([^"]+)"[^>]*>/g;
const imgWidthRegex = /data-asset-path=["']([^"']+)["']/i;
const tableRegex = /<table\b[^>]*>.*?<\/table>/g;

export function learnosityTextRender(question_stimulus: string): string {
  const audioMatch = question_stimulus.match(spanRegex);
  const videoMatch = question_stimulus.match(videoRegex);
  const imageMatch = question_stimulus.match(textImageRegex);
  const tableMatch = question_stimulus.match(tableRegex);
  
  let stimulus = question_stimulus;
  if (audioMatch) {
    audioMatch.forEach(item => {
      const srcMatch = item.match(srcRegex);
      const imageMatch = item.match(imageRegex);
      const textMatch = item.match(textRegex);
      if (srcMatch) {
        let imageHTML = '';
        if (imageMatch) {
          const imageHeight = item.match(imageHeightRegex) || '100';
          const imageWidth = item.match(imageWidthRegex) || 'auto';
          imageHTML = `<img src="${imageMatch[1]}" alt="Audio image" width="${imageWidth[1]}" height="${imageHeight[1]}">`;
        }
        const textHTML = textMatch ? `<div>${textMatch[1]}</div>` : '';
        const audioHTML = `<audio src="${srcMatch[1]}" controls></audio>`;
        const finalMarkup = `${imageHTML}${textHTML}${audioHTML}`;

        // Replace the matched item in the stimulus with the generated markup
        stimulus = stimulus.replace(item, finalMarkup);
      }
    })
  }
  if (videoMatch) {
    videoMatch.forEach(item => {
      const srcMatch = item.match(srcRegex);
      if (srcMatch) {
        const src = srcMatch[1]; // Captured URL from data-src

        let size = "";
        const heightMatch = item.match(videoHeightRegex);
        const widthMatch = item.match(videoWidthRegex);
        if (heightMatch && widthMatch) { // Captured from data-height and data-width
          size = `height="${heightMatch[1]}" width="${widthMatch[1]}"`
        }

        const videoFile = videoUrlChange(src);
        const videoHTML = `
          <iframe
            src="${videoFile}"
            ${size}
            title="Video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>`;

        // Replace the matched item in the stimulus with the generated markup
        stimulus = stimulus.replace(item, videoHTML);
      }
    })
  }
  if (tableMatch) {
    tableMatch.forEach(item => {
      const divHTML = `<div class="lrn_texteditor_editable">${item}</div>`;
      stimulus = stimulus.replace(item, divHTML);
    })
  }
  if (imageMatch) {
    imageMatch.forEach(item => {
      const srcMatch = item.match(imgWidthRegex);
      const widthSize = item.match(widthRegex) || '100';
      const image = `<img src="https://learnositymediaprocessed.s3.amazonaws.com/${srcMatch[1]}" alt="Audio image" width="${widthSize[1]}" height="auto">`;
      stimulus = stimulus.replace(item, image);
    })
  }

  return stimulus;
};
